import * as React from "react";
import styled from "styled-components";
import { Label } from "components/bootstrap";
const StyledLabel = styled(Label)`
  font-weight: bold;
`;
const SectionCountLabel = ({ children }) => /* @__PURE__ */ React.createElement(StyledLabel, { bsStyle: "default" }, children);
export default SectionCountLabel;
